export const environment = {
    production: 'false',
    appBaseHref: '/',
    oidc: {
      clientId: '0oa6ae7hzjl2rwvbd4h7',
      issuer: 'https://relayhealth.okta.com/oauth2/aus6a5udb3NjX8qza4h7',
      redirectUri: 'login/callback',
      scopes: ['openid'],
      pkce: false
    },
    resourceServer: {
      messagesUrl: ''
    },
    transactionListUrl: 'https://rxosupport-api-qa.relayhealth.com/transaction-list',
    transactionLookupUrl:'https://rxosupport-api-qa.relayhealth.com/transaction-lookup',
    pharmacyCrudUrl:'https://rxosupport-api-qa.relayhealth.com/pharmacy-crud',
    pharmacyListUrl:'https://rxosupport-api-qa.relayhealth.com/pharmacy-list',
    pharmacyLookupUrl:'https://rxosupport-api-qa.relayhealth.com/pharmacy-lookup',
    pharmacyStoresCrudUrl:'https://rxosupport-api-qa.relayhealth.com/pharmacy-stores-crud',
    configUIAPIUrl:'https://rxosupport-api-qa.relayhealth.com/config-ui-api',
    testConnectivityUrl:'https://rxosupport-api-qa.relayhealth.com/config-ui-api/testconnectivity'
  };
  